import fetchIntercept from 'fetch-intercept';
import Cookies from 'js-cookie';
const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
export const AuthInterceptor = () => {
  fetchIntercept.register({
    request: function (url, config) {
        const requestUrl = typeof url === 'string' ? url : url.url;

        if (requestUrl.includes("atlas.microsoft.com")) {
        return [url, config];
      }
      config = config || {};
      config.headers = config.headers || {};
      const accessToken = Cookies.get("idToken") ? Cookies.get("idToken") : "";
      config.headers['Authorization'] = `${accessToken}`;
      config.headers['x-functions-key'] = `${hostHeader}`;
      return [url, config];
    },

    requestError: function (error) {
      return Promise.reject(error);
    },
  });
};

